import React from "react";

const hours12 = Array.from({ length: 12 }, (_, i) => (i + 1).toString());
const hours24 = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, "0"));
const minutes = Array.from({ length: 12 }, (_, i) => (i * 5).toString().padStart(2, "0"));

function to12Hour(h24) {
  const num = parseInt(h24, 10) || 0;
  const period = num >= 12 ? "PM" : "AM";
  const h12 = num % 12 || 12;
  return { h12: h12.toString(), period };
}

function to24Hour(h12, period) {
  let num = parseInt(h12, 10) || 12;
  if (period === "AM") {
    num = num === 12 ? 0 : num;
  } else {
    num = num === 12 ? 12 : num + 12;
  }
  return num.toString().padStart(2, "0");
}

export default function TimeInput({ value, onChange, use24Hour = false, className, "data-testid": testId }) {
  const [h24, m] = (value || "00:00").split(":");
  const { h12, period } = to12Hour(h24);

  const emit = (newH24, newM) => {
    onChange({ target: { value: `${newH24}:${newM}` } });
  };

  if (use24Hour) {
    return (
      <div className={`flex items-center gap-1 ${className || ""}`} data-testid={testId}>
        <select
          value={h24 || "00"}
          onChange={(e) => emit(e.target.value, m || "00")}
          className="flex-1 h-10 sm:h-12 rounded-xl border border-input bg-background px-1.5 text-xs sm:text-sm appearance-none text-center"
        >
          {hours24.map(hour => (
            <option key={hour} value={hour}>{hour}</option>
          ))}
        </select>
        <span className="text-base font-bold text-slate-400">:</span>
        <select
          value={m || "00"}
          onChange={(e) => emit(h24 || "00", e.target.value)}
          className="flex-1 h-10 sm:h-12 rounded-xl border border-input bg-background px-1.5 text-xs sm:text-sm appearance-none text-center"
        >
          {minutes.map(min => (
            <option key={min} value={min}>{min}</option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-1 ${className || ""}`} data-testid={testId}>
      <select
        value={h12}
        onChange={(e) => emit(to24Hour(e.target.value, period), m || "00")}
        className="flex-1 h-10 sm:h-12 rounded-xl border border-input bg-background px-1 text-xs sm:text-sm appearance-none text-center"
      >
        {hours12.map(hour => (
          <option key={hour} value={hour}>{hour}</option>
        ))}
      </select>
      <span className="text-base font-bold text-slate-400">:</span>
      <select
        value={m || "00"}
        onChange={(e) => emit(to24Hour(h12, period), e.target.value)}
        className="flex-1 h-10 sm:h-12 rounded-xl border border-input bg-background px-1 text-xs sm:text-sm appearance-none text-center"
      >
        {minutes.map(min => (
          <option key={min} value={min}>{min}</option>
        ))}
      </select>
      <select
        value={period}
        onChange={(e) => emit(to24Hour(h12, e.target.value), m || "00")}
        className="h-10 sm:h-12 rounded-xl border border-input bg-background px-1 text-xs sm:text-sm appearance-none text-center w-14 sm:w-16"
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
}
